import * as React from 'react'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { Avatar, IconButton, Typography } from '@mui/material'
import { ArrowDropDown } from '@mui/icons-material'
import azFlag from '../../images/azerbaijan.png'
import ukFlag from '../../images/united-kingdom.png'
import ruFlag from '../../images/ru.png'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { useChangeUserLanguageMutation } from '../../store/api/userApi'

export default function BasicMenu({ color }) {
    const { t, i18n } = useTranslation('login')

    const [anchorEl, setAnchorEl] = React.useState(null)
    const open = Boolean(anchorEl)
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }


    const [postLanguage] = useChangeUserLanguageMutation()
    const handleLanguageChange = (language) => {
        i18n.changeLanguage(language)

        localStorage.setItem('lang', language)

        postLanguage(language)
        handleClose()

        window.location.reload();
    }

    useEffect(() => {
        const storedLang = localStorage.getItem('lang')
        if (storedLang) {
            i18n.changeLanguage(storedLang)
        }
    }, [i18n])

    const langItem = (key, text, flag) => {
        return { key, text, flag }
    }

    const data = [
        langItem('en', 'English', ukFlag),
        langItem('az', 'Azerbaijani', azFlag),
        // langItem('ru', 'Russian', ruFlag),
    ]

    return (
        <div>
            <IconButton style={{ color: color }} onClick={handleClick} size="small">
                <Avatar src={data.find(item => item.key === i18n.language)?.flag} sx={{ width: 20, height: 20, mr: 1 }}
                    variant="square" />
                <span style={{ color: color }}>{t('language')}</span>
                <ArrowDropDown />
            </IconButton>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {data.map(item => (
                    <MenuItem key={item.key} onClick={() => handleLanguageChange(item.key)} disabled={item.key === i18n.language}>
                        <Avatar src={item.flag} sx={{ width: 20, height: 20, mr: 1 }} variant="square" />
                        <Typography variant="inherit">{item.text}</Typography>
                    </MenuItem>
                ))}
            </Menu>
        </div>
    )
}
